<ng-container>
	<h4 class="explore-categories">Explore categories</h4>
	<nav class="facetContainer" aria-label="Search category navigation">
		<div class="facets">
			<a
				cdxButton
				[attr.aria-label]="'Category - ' + facet.name"
				fillStyle="outline"
				focusVisibleStyle="dark-dashed"
				[inline]="true"
				[routerLink]="[dasFacetsRoute[i]]"
				[queryParams]="dasFacetsQueryParams[i]"
				[checked]="this.currentIndex === i"
				(click)="handleClickDasFacet($event, i)"
				*ngFor="let facet of dasFacets; index as i; trackBy: trackByFacet"
			>
				{{ facet.name | titlecase }} ({{ facet.productCount }})
			</a>
		</div>
	</nav>
</ng-container>
